"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { Icon as t } from "../Icon/Icon.mjs";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import * as i from "@radix-ui/react-accordion";
//#region src/components/atoms/Accordion/Accordion.tsx
var a = ({ ...e }) => /* @__PURE__ */ n(i.Root, {
	"data-slot": "accordion",
	...e
});
function o({ className: t, ...r }) {
	return /* @__PURE__ */ n(i.Item, {
		"data-slot": "accordion-item",
		className: e("border-b last:border-b-0", t),
		...r
	});
}
function s({ className: a, iconClassName: o, children: s, ...c }) {
	return /* @__PURE__ */ n(i.Header, { children: /* @__PURE__ */ r(i.Trigger, {
		"data-slot": "accordion-trigger",
		className: e("focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 flex flex-1 items-start justify-between gap-4 text-left hover:cursor-pointer transition-all outline-none disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180", a),
		...c,
		children: [s, /* @__PURE__ */ n(t, {
			name: "chevronDown",
			className: e("pointer-events-none size-3 translate-y-0.5 transition-transform duration-200", o)
		})]
	}) });
}
function c({ className: t, children: r, ...a }) {
	return /* @__PURE__ */ n(i.Content, {
		"data-slot": "accordion-content",
		className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
		...a,
		children: /* @__PURE__ */ n("div", {
			className: e("", t),
			children: r
		})
	});
}
//#endregion
export { c as AccordionContent, o as AccordionItem, a as AccordionRoot, s as AccordionTrigger };
